import React, {
  FC,
  useState,
  useContext,
  createContext,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import { getMessageThread } from "../apis/message";
import { handleApiError } from "../helpers";
import { Pagination } from "../interfaces/common";
import { MessageThread } from "../interfaces/message";

type MessageThreadContext = {
  messageThread: MessageThread[];
  fetching: boolean;
  fetchMessageThread: (key: string, refresh?: boolean) => {};
};
const messageThreadContext = createContext({} as MessageThreadContext);

export const MessageThreadProvider: FC = ({ children }) => {
  const [messageThread, setMessageThread] = useState<MessageThread[]>([]);
  const [fetching, setFetching] = useState(false);

  const fetchMessageThread = useCallback(async (key: string, refresh: boolean = true) => {
    try {
      if (refresh) setFetching(true);
      const response = await getMessageThread(key);
      const paginatedData: Pagination = response.data;
      const thread = paginatedData.data as MessageThread[];

      setMessageThread(thread.reverse());
      if (refresh) setFetching(false);
    } catch (error) {
      console.log(error);
      if (refresh) setFetching(false);
      toast.error(handleApiError(error));
    }
  }, []);

  return (
    <messageThreadContext.Provider
      value={{ messageThread, fetching, fetchMessageThread }}
    >
      {children}
    </messageThreadContext.Provider>
  );
};

export const useMessageThread = () => {
  const { messageThread, fetching, fetchMessageThread } = useContext(messageThreadContext);
  return { messageThread, fetching, fetchMessageThread };
};
